
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.984 1.57v.063c1.11.656 1.664 1.664 1.664 3.023 0 1.063-.32 1.907-.96 2.532-.641.625-1.49.937-2.547.937-1.021 0-1.836-.323-2.446-.969-.61-.646-.914-1.49-.914-2.531 0-1.047.222-1.883.664-2.508.448-.63 1.01-1.054 1.688-1.273C3.81.625 4.648.516 5.648.516h3.149V1.57H5.984zm-1.007.032c-1.823 0-2.735 1.013-2.735 3.039 0 .911.17 1.617.508 2.117.339.5.807.75 1.406.75 1.36 0 2.04-.935 2.04-2.805 0-1.281-.407-2.315-1.22-3.101z","fill":"currentColor"}})])
          )
        }
      }
    